<template>
	<div class="search-iCard">
		<div class="el-search vue-top-padding radius">
			<el-row :gutter="20">
				<el-col :span="24">
					<div class="el-right">
						<el-form
							ref="card"
							:model="search"
							:inline="true"
							label-width="10px"
							size="small"
							class="demo-form-inline el-input-height">
							<el-form-item>
								<el-date-picker
									v-model="dateTime"
									type="datetimerange"
									format="yyyy-MM-dd HH:mm:ss"
									value-format="yyyy-MM-dd HH:mm:ss"
									range-separator="-"
									:start-placeholder="$t('searchProductProfit.start')"
									:end-placeholder="$t('searchProductProfit.end')">
								</el-date-picker>
							</el-form-item>
							<el-form-item>
								<el-button
									type="primary"
									@click="onSubmit"
									icon="el-icon-search"
									>{{ $t("common.search") }}</el-button
								>
								<el-button
									@click="resetSearch('card')"
									icon="el-icon-refresh"
									>{{ $t("common.reset") }}</el-button
								>
							</el-form-item>
						</el-form>
					</div>
				</el-col>
			</el-row>
		</div>
		<el-dialog
			:modal-append-to-body="true"
			:append-to-body="true"
			:title="$t('searchICard.title')"
			:visible.sync="dialogImportICard"
			width="30%"
			top="9vh"
			@closed="closeDialog">
			<div v-loading="loading">
				<el-upload
					class="upload-demo"
					drag
					accept=".xls,.xlsx"
					multiple
					ref="upload"
					:before-upload="beforeUpload"
					:on-progress="onProgress"
					:on-success="onSuccess"
					limit="1"
					:headers="headers"
					:auto-upload="false"
					:action="url">
					<i class="el-icon-upload"></i>
					<div class="el-upload__text">
						{{ this.$t("searchICard.text") }}
						<em>{{ this.$t("searchICard.sub") }}</em>
					</div>
					<div class="el-upload__tip" slot="tip">
						{{ this.$t("searchICard.tip") }}
					</div>
				</el-upload>
				<vue-scroll>
					<div class="result" v-show="result.length > 0">{{ result }}</div>
				</vue-scroll>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button
					@click="downloadTemplate"
					v-hasPerm="['machine:template']"
					style="float: left"
					>{{ this.$t("searchICard.down") }}</el-button
				>
				<el-button @click="dialogImportICard = !dialogImportICard">{{
					$t("common.cancel")
				}}</el-button>
				<el-button type="primary" @click="submitUpload()">{{
					$t("common.definite")
				}}</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import config from "@/http/config";
export default {
	name: "SearchICard",
	props: {
		search: Object,
		dialogImportICard: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			loading: false,
			url: config.baseUrl + this.$url.ICard.import,
			headers: {
				token: this.$store.getters.token,
			},
			result: "",
			importResult: "",
			dateTime: "",
		};
	},
	methods: {
		importICard() {
			this.dialogImportICard = true;
		},
		exportICard() {},
		onSubmit() {
			if (this.dateTime && this.dateTime.length > 0) {
				this.search.startTime = this.dateTime[0];
				this.search.endDate = this.dateTime[1];
			}
			this.$emit("onSubmit", this.search);
		},
		resetSearch(formName) {
			this.dateTime = "";
			this.$refs[formName].resetFields();
			this.$toolUtil.clearForm(this.search);
			this.$emit("resetSearch", this.search);
		},
		downloadTemplate() {
			this.$api.download(this.$url.ICard.template);
		},
		submitUpload() {
			this.$refs.upload.submit();
		},
		closeDialog() {
			this.$refs.upload.clearFiles();
			this.result = "";
		},
		beforeUpload(file) {
			let type = false;
			if (file.type === "") {
				let fileName = file.name;
				if (
					fileName !== "" &&
					(fileName.indexOf(".xls") > 0 || fileName.indexOf(".xlsx") > 0)
				) {
					type = true;
				} else {
					this.$message.error(this.$t("searchICard.type"));
				}
			} else {
				type =
					file.type === "application/vnd.ms-excel" ||
					file.type ===
						"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
				if (!type) {
					this.$message.error(this.$t("searchICard.type"));
				}
			}
			let size = file.size / 1024 < 500;
			if (!size) {
				this.$message.error(this.$t("searchICard.size"));
			}
			return type && size;
		},
		onProgress() {
			this.loading = true;
		},
		onSuccess(res) {
			if (res.code === 0) {
				this.importResult = JSON.parse(res.data);
				this.result = "";
				this.result = res.msg;
				let msg =
					this.importResult.error > 0
						? this.$t("searchICard.impS").replace(
								"N",
								this.importResult.success
						) +
						"，" +
						this.$t("searchICard.impE").replace("N", this.importResult.error)
						: this.$t("searchICard.impS").replace(
								"N",
								this.importResult.success
						);
				this.$notify({
					title: this.$t("common.tip"),
					message: msg,
					type: "success",
				});
			}
			this.loading = false;
		},
	},
};
</script>

<style lang="scss">
.search-iCard {
	.el-upload--text,
	.el-upload-dragger {
		width: 100%;
	}
	.result {
		margin-top: 10px;
		color: #f56c6c;
		max-height: 60px;
	}
}
</style>
